import axios from "axios";

// const _protocol = window.location.protocol;
// 请求接口
export const getRequest = (
  name = "",
  params = {},
  version = "api/v1/",
  header = null
) => {
  const token = sessionStorage.getItem("token")
    ? sessionStorage.getItem("token")
    : "";
  axios.defaults.headers.common["token"] = token;
  if (header) {
    for (let item of Object.keys(header)) {
      axios.defaults.headers.common[item] = header[item];
    }
  }
  let url = `/${version}${name}`;
  let suffix = "";

  for (let key of Object.keys(params)) {
    if (suffix === "") {
      suffix = `?${key}=${params[key]}`;
    } else {
      suffix += `&${key}=${params[key]}`;
    }
  }

  return axios.get(`${url}${suffix}`);
};

export const postRequest = (
  name = "",
  params = {},
  version = "api/v1/",
  header = null
) => {
  const token = sessionStorage.getItem("token")
    ? sessionStorage.getItem("token")
    : "";
  axios.defaults.headers.common["token"] = token;

  if (header) {
    for (let item of Object.keys(header)) {
      axios.defaults.headers.common[item] = header[item];
    }
  }

  const url = `/${version}${name}`;

  return axios.post(url, params, {timeout: 3 * 60 * 1000});
};

export const getCaptcha = (uuid) => {
  const token = sessionStorage.getItem("token")
    ? sessionStorage.getItem("token")
    : "";
  axios.defaults.headers.common["token"] = token;

  const url = `/captcha.jpg?uuid=${uuid}`;

  return axios.get(url, { responseType: "arraybuffer" });
};

export const downloadQuotaTemplate = (quotaTableId) => {
  const token = sessionStorage.getItem("token")
    ? sessionStorage.getItem("token")
    : "";
  axios.defaults.headers.common["token"] = token;

  const url = `/api/v1survey/quota/download/${quotaTableId}?token=${token}`;
  window.open(url);
};
